import { RBChannel } from 'store/railsBuilder/reducer.types';

function isCatchupChannel(channel: RBChannel) {
    return channel.editorial.catchUpSupport && channel.technical.catchUpSupport;
}

export default isCatchupChannel;
